import * as types from '../../../../../constants/ActionNameConstants';

// Proofreader all files
export const proofreaderAllFilesRequest = (payload) => ({
  type: types.GET_PROOFREADER_ALL_FILES_LIST_REQUEST,
  payload,
});

export const proofreaderAllFilesSuccess = (payload) => ({
  type: types.GET_PROOFREADER_ALL_FILES_LIST_SUCCESS,
  payload,
});

export const proofreaderAllFilesFailure = (error) => ({
  type: types.GET_PROOFREADER_ALL_FILES_LIST_FAILED,
  error,
});

export const resetProofreaderAllFiles = () => {
  return {
    type: types.RESET_PROOFREADER_ALL_FILES_LIST,
  };
};

// Proofreader files filter
export const proofreaderFilesFilterRequest = (payload) => ({
  type: types.GET_PROOFREADER_FILES_FILTER_LIST_REQUEST,
  payload,
});

export const proofreaderFilesFilterSuccess = (payload) => ({
  type: types.GET_PROOFREADER_FILES_FILTER_LIST_SUCCESS,
  payload,
});

export const proofreaderFilesFilterFailure = (error) => ({
  type: types.GET_PROOFREADER_FILES_FILTER_LIST_FAILED,
  error,
});
